'use client';

import { useTranslation } from '@/lib/i18n';
import BookmarkButton from '../../ui/BookmarkButton';
import { useFollowing } from '@/hooks/useFollowing';
import Image from 'next/image';
import Link from 'next/link';

interface MarketHeaderProps {
  title: string;
  marketEventId: string | number;
  polymarketUrl: string;
}
export default function MarketHeader({ title, marketEventId, polymarketUrl }: MarketHeaderProps) {
  const { t } = useTranslation();

  const { isFollowed, toggleFollow, isFollowing } = useFollowing(
    marketEventId ? `${marketEventId}` : null,
  );

  return (
    <div>
      <h1 className="font-semibold text-[40px] leading-11 mb-4">{title}</h1>
      <div className="flex items-center justify-between mb-6">
        <Link
          href={polymarketUrl}
          target="_blank"
          className="flex items-center justify-center gap-2 text-sm"
        >
          <span className="flex items-center justify-center size-5 bg-blue-600 rounded-full">
            <Image src="/image/polymarket.svg" width={10} height={10} alt="polymarket" />
          </span>
          <span className="underline">Polymarket</span>
        </Link>
        <BookmarkButton
          isFollowing={isFollowing}
          isFollowed={isFollowed}
          toggleFollow={toggleFollow}
          description={isFollowed ? t('Following') : t('Follow')}
          className="rounded-full py-1"
        />
      </div>
    </div>
  );
}
